<template>
  <div class="social-step-editor-main">
    <div class="social-step-editor-main__content">
      <slot />
      <shared-step-editor-footer-actions
        @undo="$emit('undo')"
        @redo="$emit('redo')"
        :canUndo="canUndo"
        :canRedo="canRedo"
      />
    </div>
  </div>
</template>

<script>
import SharedStepEditorFooterActions from '../../shared/SharedStepEditorFooterActions';
export default {
  components: {SharedStepEditorFooterActions},
  props: {
    canUndo: Boolean,
    canRedo: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../../sass/web/_variables';

.social-step-editor-main {
  inset: 0px 425px 0px 0px;
  background-color: rgb(255, 255, 255);
  background-image: linear-gradient(45deg, rgb(247, 247, 247) 25%, transparent 25%),
    linear-gradient(-45deg, rgb(247, 247, 247) 25%, transparent 25%),
    linear-gradient(45deg, transparent 75%, rgb(247, 247, 247) 75%),
    linear-gradient(-45deg, transparent 75%, rgb(247, 247, 247) 75%);
  background-size: 20px 20px;
  background-position: 0px 0px, 0px 10px, 10px -10px, -10px 0px;
  display: flex;
  justify-content: center;
  position: relative;
  overflow: auto;
  &__content {
    max-width: 500px;
    width: 100%;
    background: $white-color;
    margin: 24px;
    position: relative;
    height: fit-content;
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    transition: all 0.3s;
    transform-origin: top center;
    text-align: left;
  }
}
</style>
